import { render, staticRenderFns } from "./claimItem.vue?vue&type=template&id=10782757&scoped=true"
import script from "./claimItem.vue?vue&type=script&lang=js"
export * from "./claimItem.vue?vue&type=script&lang=js"
import style0 from "./claimItem.vue?vue&type=style&index=0&id=10782757&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10782757",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10782757')) {
      api.createRecord('10782757', component.options)
    } else {
      api.reload('10782757', component.options)
    }
    module.hot.accept("./claimItem.vue?vue&type=template&id=10782757&scoped=true", function () {
      api.rerender('10782757', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/productManage/claimItem.vue"
export default component.exports